module.exports = __webpack_public_path__ + "img/company_introduction.36aa6164.png";